import { schema } from "normalizr";
export const commentsSchema = new schema.Entity("comments", {});
export const commentListSchema = [commentsSchema];
